declare global {
  interface Window {
    gtag?: (
      command: string,
      action: string,
      params?: Record<string, any>
    ) => void;
  }
}

export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
    console.log('GA4 Event:', eventName, eventParams);
  } else {
    console.warn('Google Analytics not available');
  }
};

export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location || window.location.pathname,
  });
};

export const trackNavigation = (destination: string, linkText: string) => {
  trackEvent('navigation_click', {
    destination,
    link_text: linkText,
    source: window.location.pathname,
  });
};

export const trackFormSubmission = (formName: string, formData?: Record<string, any>) => {
  trackEvent('form_submission', {
    form_name: formName,
    ...formData,
  });
};

export const trackServiceInteraction = (serviceName: string, action: string) => {
  trackEvent('service_interaction', {
    service_name: serviceName,
    action,
  });
};

export const trackModalOpen = (modalName: string) => {
  trackEvent('modal_open', {
    modal_name: modalName,
  });
};

export const trackModalClose = (modalName: string) => {
  trackEvent('modal_close', {
    modal_name: modalName,
  });
};

export const trackBlogInteraction = (action: string, blogTitle: string, blogId?: number) => {
  trackEvent('blog_interaction', {
    action,
    blog_title: blogTitle,
    blog_id: blogId,
  });
};

export const trackReviewInteraction = (action: string, reviewData?: Record<string, any>) => {
  trackEvent('review_interaction', {
    action,
    ...reviewData,
  });
};

export const trackPricePackageInteraction = (packageName: string, action: string) => {
  trackEvent('price_package_interaction', {
    package_name: packageName,
    action,
  });
};

export const trackExternalLink = (url: string, linkText: string, location?: string) => {
  trackEvent('external_link_click', {
    url,
    link_text: linkText,
    location: location || window.location.pathname,
  });
};
